import { Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/InfoDevice/InfoDeviceModel';
import { RootState } from '../../../store';
import InfoDeviceForm from '../InfoDeviceForm/InfoDeviceForm';

const InfoDeviceModal: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxInfoDevice = useSelector((state: RootState) => state.models.infoDevice);

  return (
    <Modal
      title={!!reduxInfoDevice.id ? 'Modifica' : 'Adauga'}
      open={reduxInfoDevice.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <InfoDeviceForm />
    </Modal>
  );
};

export default InfoDeviceModal;
